import { AppContext } from "@components/features/appContext/AppContext";
import Header from "@components/features/header/Header";
import { config } from "@utils/config";
import { useContext, useEffect } from "react";
import Loading from "react-loading";

type Props = {
  children: React.ReactNode | React.ReactNode[];
};

const Layout = ({ children }: Props) => {
  const { setIsLoading, isLoading, setLanguage, setTheme } =
    useContext(AppContext);

  useEffect(() => {
    setLanguage(
      localStorage.getItem(config.localStorage.language) ||
        (config.default.language as string)
    );
    setTheme(localStorage.getItem(config.localStorage.theme) || ("" as string));
    setTimeout(() => {
      setIsLoading(false);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  });

  return (
    <>
      <div className="bg-primary h-screen w-full">
        <Header />
        <main className="bg-primary text-primary h-screen w-full">
          {!isLoading ? (
            children
          ) : (
            <div className="flex justify-center items-center w-full h-screen">
              <Loading color="lightblue" type="spin" />
            </div>
          )}
        </main>
      </div>
    </>
  );
};

export default Layout;
